
import { apiCall } from './apiCall';
  
  
  
export default function brandApi() {
  return {
    getBrandsList: (data,token) => apiCall('/getBrandsList',data, token),
    getBrandList: (data,token) => apiCall('/getBrands',data, token),
    getBrandById: (data,token) => apiCall('/getBrandById',data, token),
    update: (data,token) => apiCall('/updateBrand',data, token),
    delete: (data,token) => apiCall('/deleteBrand',data, token),
    create: (data,token) => apiCall('/addBrand',data, token),
    getBrands: (data,token) => apiCall('/getBrands',data, token),


  };
}
